export class NoExtensionInstalledError extends Error {
  message = "Freighter does not appear to be installed.";
}
